<template>
  <div class="search-form">
    <div class="window-container">
      <div class="page-container">
        <h3 class="headline">
          Critères de recherche :
        </h3>
        <v-form
          ref="form"
          class="mt-8"
        >
          <v-text-field
            v-model="form.orthaoNumber"
            outlined
            hide-details
            class="mb-4"
            label="N° Orthao"
          />
          <v-text-field
            v-model="form.patientLastname"
            outlined
            hide-details
            class="mb-4"
            label="Nom"
          />
          <v-text-field
            v-model="form.patientFirstname"
            outlined
            hide-details
            class="mb-4"
            label="Prénom"
          />

          <!-- Date picker for dataFrom -->
          <v-menu
            ref="datePicker1"
            v-model="datePicker1"
            :close-on-content-click="false"
            :return-value.sync="form.dateFrom"
            transition="scale-transition"
            offset-y
            full-width
            color="#880e4f"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.dateFrom"
                label="Date du"
                readonly
                hide-details
                outlined
                class="mb-4"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="form.dateFrom"
              no-title
              scrollable
            >
              <div class="flex-grow-1" />
              <v-btn
                text
                color="#880e4f"
                @click="datePicker1 = false"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="#880e4f"
                @click="$refs.datePicker1.save(form.dateFrom)"
              >
                Ok
              </v-btn>
            </v-date-picker>
          </v-menu>

          <!-- Date picker for dateTo -->
          <v-menu
            ref="datePicker2"
            v-model="datePicker2"
            :close-on-content-click="false"
            :return-value.sync="form.dateTo"
            transition="scale-transition"
            offset-y
            full-width
            color="#880e4f"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.dateTo"
                label="Date au"
                readonly
                hide-details
                outlined
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="form.dateTo"
              no-title
              scrollable
            >
              <div class="flex-grow-1" />
              <v-btn
                text
                color="primary"
                @click="datePicker2 = false"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.datePicker2.save(form.dateTo)"
              >
                Ok
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-layout
            justify-center
            mt-8
          >
            <v-btn
              rounded
              x-large
              color="error"
              class="mr-4"
              @click="$emit('cancel')"
            >
              <v-icon>mdi-close</v-icon>Annuler
            </v-btn>
            <v-btn
              rounded
              x-large
              color="success"
              @click="$emit('search', form)"
            >
              <v-icon>mdi-magnify</v-icon>Rechercher
            </v-btn>
          </v-layout>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchForm",
  data: () => ({
    datePicker1: false,
    datePicker2: false,
    form: {
      orthaoNumber: null,
      patientFirstname: null,
      patientLastname: null,
      dateFrom: null,
      dateTo: null
    }
  })
};
</script>

<style lang="scss">
.search-form {
  .window-container {
    height: calc(100vh - 56px - 60px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 55px 45px;
    .page-container {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
  }
  .v-btn {
    &.success {
      background-color: #006064 !important;
    }
    &.error {
      background-color: #880e4f !important;
    }
  }
  h3 {
    position: relative;
    display: inline;
    &::before {
      position: absolute;
      top: 60%;
      left: 106%;
      background-color: #880e4f;
      height: 1px;
      width: calc(100vw - 45px * 2 - 100%);
      content: "";
      display: block;
    }
  }
}
</style>
